import React from "react";
import { useLang } from "../i18n/LanguageContext";

const Marquee = () => {
  const { t } = useLang();
  const items = t.marquee;
  const row = [...items, ...items, ...items, ...items];
  return (
    <div className="relative overflow-hidden border-y border-white/10 bg-obsidian py-6" data-testid="marquee">
      <div className="animate-marquee flex whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="mx-8 flex items-center gap-8 font-serif text-3xl md:text-4xl italic text-white/70">
            {item}
            <span className="text-champagne text-lg not-italic">✦</span>
          </span>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-obsidian to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-obsidian to-transparent" />
    </div>
  );
};

export default Marquee;
